import { AliasResponseI } from '../models/Alias';
import { AliasFormInterface } from '../pages/Settings/Alias/AliasConstants';
import APIClient from '../services/APIClient';

export const getAllAlias = async (
  page: number,
  page_size: number,
  filters: string,
  order: string,
) => {
  const clientAPI = new APIClient();
  const aliasResponse = await clientAPI.client.get<AliasResponseI>(
    `/aliases/?page=${page}&page_size=${page_size}${
      order !== '' ? `&ordering=${order}` : ''
    }${filters}`,
  );
  return aliasResponse.data;
};
export const postNewAlias = async (obj: AliasFormInterface) => {
  const clientAPI = new APIClient();
  const aliasResponse = await clientAPI.client.post('/aliases/', obj);
  return aliasResponse.data;
};

export const editActiveAlias = async (obj: AliasFormInterface, id: number) => {
  const clientAPI = new APIClient();
  const aliasResponse = await clientAPI.client.put(`/aliases/${id}/`, obj);
  return aliasResponse.data;
};

export const sendTestAliasEndpoint = async (id: number) => {
  const clientAPI = new APIClient();
  const aliasResponse = await clientAPI.client.post(
    `/aliases/${id}/validate-alias/`,
  );
  return aliasResponse.data;
};
